export default __webpack_public_path__ + "static/media/ZahrahforDouglasW04-SmBd.313370c8.woff";